import Ajax from '../util/ajax';
import { createAction } from '@reduxjs/toolkit';
const THROTTLE_TIMEOUT = 200; // milliseconds
export const throttleSentAction = createAction('throttle/sent');
export const throttleQueueAddAction = createAction('throttle/queue_add');
export const throttleQueueUpdateAction = createAction('throttle/queue_update');
export function throttle(endpoint, data, success, failure) {
    return (dispatch, getState) => {
        const ajax = new Ajax(dispatch);
        function send() {
            ajax.post(endpoint, data, success, failure);
            dispatch(throttleSentAction(endpoint));
        }
        function timeout_send() {
            const { throttle } = getState();
            const t = throttle[endpoint];
            if (t == undefined)
                return;
            if (t.post == null)
                return;
            window.clearInterval(t.post.intervalId);
            ajax.post(endpoint, t.post.data, t.post.success, t.post.failure);
            dispatch(throttleSentAction(endpoint));
        }
        const { throttle } = getState();
        if (!(endpoint in throttle)) {
            send();
        }
        else {
            const t = throttle[endpoint];
            if (t != undefined) {
                if (t.post == null) {
                    // nothing is queued
                    const timeSinceLast = Date.now() - t.timestamp;
                    if (timeSinceLast > THROTTLE_TIMEOUT) { // more than 100ms ago, send direct
                        send();
                    }
                    else {
                        const intervalId = window.setInterval(() => timeout_send(), THROTTLE_TIMEOUT - timeSinceLast);
                        dispatch(throttleQueueAddAction({
                            endpoint,
                            data,
                            success,
                            failure,
                            intervalId
                        }));
                    }
                }
                else {
                    // we are already waiting to send something, change it to our new value
                    dispatch(throttleQueueUpdateAction({
                        endpoint,
                        data,
                        success,
                        failure,
                        intervalId: t.post.intervalId
                    }));
                }
            }
        }
    };
}
